// extracted by mini-css-extract-plugin
export default {"container":"Mk-z","blurb":"Nk-z","links":"Ok-z"};